var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('vs-button',{attrs:{"size":_vm.params.size,"color":_vm.buttonColor(),"type":"filled","disabled":_vm.isButtonDisabled()},on:{"click":_vm.clicked}},[_vm._v("\n  "+_vm._s(_vm.params.name)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }